import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LabelsProviderPipe } from 'src/app/pipes/labels-provider/labels-provider.pipe';

@Component({
  selector: 'app-no-access',
  standalone: true,
  imports: [CommonModule, LabelsProviderPipe],
  templateUrl: './no-access.component.html',
  styleUrls: ['./no-access.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoAccessComponent {}
